/* eslint-disable eqeqeq */
import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  Dropdown, Select, Table, Tag, Checkbox, Drawer, DatePicker, Popconfirm, Popover, Tooltip,
  Alert,
  Divider,
  notification,
} from 'antd';
import {
  ControlOutlined,
  FilterOutlined,
  EditOutlined,
  SwapOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  CaretDownFilled,
  ExperimentOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload, faFlask, faPen } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Helpers from '@Apis/helpers';
import constants, { QUANTITY, toISTDate, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3Text from '@Uilib/h3Text';
import searchIcon from '@Images/icons/icon-search.png';
import H3Image from '@Uilib/h3Image';
import H3FormInput from '@Uilib/h3FormInput';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import CategoryActions from '@Actions/categoryActions';
import ProductActions from '@Actions/productActions';
import InventoryLocationActions from '@Actions/settings/inventoryLocationActions';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import TenantActions from '@Actions/tenantActions';
import H3DateSelector from '@Uilib/h3DateSelector';
import PrintBarcodes from '@Components/Inventory/PrintBarcodes';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import MultiStockAdjustmentForm from './MultiStockAdjustmentForm';
import BulkUpdateBatchForm from './BulkUpdateBatchForm';
import AnalyticsActions from '../../../../actions/application/analyticsActions';
import CategoryFilterNew from '../../../Common/CategoryFilterNew';
import QualityCheckActions from '../../../../actions/quality/qualityCheckActions';
import QCList from './QCList';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import CustomFieldHelpers from '../../../../helpers/CustomFieldHelpers';
import CustomFieldLine from '../../../Common/CustomFieldLine';
import PRZText from '../../../Common/UI/PRZText';
import ListScreenKeys from './mobileListHelper';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import {
  dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums,
} from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import './style.scss';

const { Option } = Select;

function InventoryLookup({
  history, user, org, getBatches, getBatchesDataLoading, getBatchesLoading, batchesData, updateBatch, updateBatchesLoading, inventoryLocations, getInventoryLocationsLoading, getInventoryLocations, departments, getCategories, MONEY, downloadProductBatchesListLoading, downloadProductBatchesList, downloadDocument, subCategories,
  retestQualityCheck, retestQualityCheckLoading, priceMasking, customFieldsProps,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [availableStocks, setAvailableStocks] = useState();
  const [expiryStartDate, setExpiryStartDate] = useState('');
  const [expiryEndDate, setExpiryEndDate] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [sortOrder, setSortOrder] = useState('ASC');
  const [isExpired, setIsExpired] = useState('');
  const [sortOrderByExpiryDate, setSortOrderByExpiryDate] = useState('');
  const [sortOrderByProductName, setSortOrderByProductName] = useState('');
  const [minCostPrice, setMinCostPrice] = useState(0);
  const [maxCostPrice, setMaxCostPrice] = useState(0);
  const [minMRP, setMinMRP] = useState(0);
  const [maxMRP, setMaxMRP] = useState(0);
  const [updatedMRP, setUpdatedMRP] = useState('');
  const [updatedCostPrice, setUpdatedCostPrice] = useState('');
  const [updatedSellingPrice, setUpdatedSellingPrice] = useState('');
  const [updatedBatchNumber, setUpdatedBatchNumber] = useState('');
  const [updatedLotNumber, setUpdatedLotNumber] = useState('');
  const [updatedRollNumber, setUpdatedRollNumber] = useState('');
  const [updatedLastQcDate, setUpdatedLastQcDate] = useState('');
  const [updatedNextQcDate, setUpdatedNextQcDate] = useState('');
  const [updatedFreightCost, setUpdatedFreightCost] = useState('');
  const [updatedOtherCost, setUpdatedOtherCost] = useState('');
  const [updatedLandedCost, setUpdatedLandesCost] = useState('');
  const [updatedBrand, setUpdatedBrand] = useState('');
  const [updatedMfgBatchNumber, setUpdatedMfgBatchNumber] = useState('');
  const [updatedMfgDate, setUpdatedMfgDate] = useState('');
  const [updatedBatchQuality, setUpdatedBatchQuality] = useState('');
  const [updatedExpiryDate, setUpdatedExpiryDate] = useState(0);
  const [updatedArNumber, setUpdatedArNumber] = useState('');
  const [updatedBarcode, setUpdatedBarcode] = useState('');
  const [updatedCustomFields, setUpdatedCustomFields] = useState();
  const [lineData, setLineDate] = useState(null);
  const [selectedFilterTenantDepartment, setSelectedFilterTenantDepartment] = useState('');
  const [selectedTenantDepartment, setSelectedTenantDepartment] = useState('');
  const [selectedInventoryLocation, setSelectedInventoryLocation] = useState('');
  const [selectedInventoryLocationName, setSelectedInventoryLocationName] = useState('');
  const [selectedFilterInventoryLocation, setSelectedFilterInventoryLocation] = useState('');
  const [selectedFilterInventoryLocationName, setSelectedFilterInventoryLocationName] = useState('');
  const [isRejectedBatch, setIsRejectedBatch] = useState('');
  const [expiryStatus, setExpiryStatus] = useState('');
  const [open, setOpen] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showActionDropdown, setShowActionDropdown] = useState(false);
  const [showMultiStockAdjustmentForm, setShowMultiStockAdjustmentForm] = useState(false);
  const [showBulkUpdateBatchForm, setShowBulkUpdateBatchForm] = useState(false);
  const [showStockTransferDrawer, setShowStockTransferDrawer] = useState(false);
  const [showPrintBarcodeDrawer, setShowPrintBarcodeDrawer] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [call, setCall] = useState(false);
  const [pendingForQcRetest, setPendingForQcRetest] = useState(false);
  const [data, setData] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-inventory-lookup') ? JSON.parse(localStorage.getItem('prcz-page-columns-inventory-lookup')) : {
    SKU_CODE: {
      label: 'SKU #',
      visible: true,
      hidden: false,
    },
    QC_NUMBER: {
      label: 'QC Number',
      visible: true,
      hidden: false,
    },
    INTERNAL_SKU_CODE: {
      label: 'Internal SKU #',
      visible: false,
      hidden: false,
    },
    PRODUCT_NAME: {
      label: 'Product',
      visible: true,
      hidden: false,
    },
    BUSINESS_UNIT: {
      label: 'Business Unit',
      visible: true,
      hidden: false,
    },
    DEPARTMENT: {
      label: 'Department',
      visible: true,
      hidden: false,
    },
    BATCH_NUMBER: {
      label: 'Batch #',
      visible: true,
      hidden: false,
    },
    LOT_NUMBER: {
      label: 'Lot #',
      visible: true,
      hidden: true,
    },
    AR_NUMBER: {
      label: 'AR Number',
      visible: true,
      hidden: true,
    },
    VENDOR: {
      label: 'Vendor',
      visible: true,
      hidden: true,
    },
    BATCH_QUALITY: {
      label: 'Batch Quality',
      visible: true,
      hidden: false,
    },
    BARCODE: {
      label: 'Barcode',
      visible: true,
      hidden: true,
    },
    COST_PRICE: {
      label: 'Cost Price',
      visible: true,
      hidden: false,
    },
    SELLING_PRICE: {
      label: 'Selling Price',
      visible: true,
      hidden: true,
    },
    MRP: {
      label: 'MRP',
      visible: true,
      hidden: true,
    },
    CATEGORY: {
      label: 'Batch Quality',
      visible: false,
      hidden: false,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
      hidden: false,
    },
    CREATED_BY: {
      label: 'Created By',
      visible: true,
      hidden: false,
    },
    EXPIRY_DATE: {
      label: 'Expiry',
      visible: true,
      hidden: false,
    },
    TAX: {
      label: 'Tax',
      visible: false,
      hidden: false,
    },
    MIN_QTY: {
      label: 'Reorder level',
      visible: false,
      hidden: false,
    },
    ON_HAND_STOCK: {
      label: 'On Hand Stock',
      visible: true,
      hidden: false,
    },
    RESERVED_STOCK: {
      label: 'Reserved Stock',
      visible: true,
      hidden: false,
    },
    AVAILABLE_STOCK: {
      label: 'Available Stock',
      visible: true,
      hidden: false,
    },
    BATCH_INWARD_DATE: {
      label: 'Batch Inward Date',
      visible: true,
      hidden: true,
    },
    ROLL_NO: {
      label: 'Roll Number #',
      visible: true,
      hidden: true,
    },
    NEXT_QC_DATE: {
      label: 'Next QC Date',
      visible: true,
      hidden: true,
    },
    LAST_QC_DATE: {
      label: 'Last QC Date',
      visible: true,
      hidden: true,
    },
    FREIGHT_COST: {
      label: 'Freight Cost',
      visible: true,
      hidden: true,
    },
    OTHER_COST: {
      label: 'Other Cost',
      visible: true,
      hidden: true,
    },
    LANDED_COST: {
      label: 'Landed Cost',
      visible: true,
      hidden: true,
    },
    MARGIN: {
      label: 'Margin',
      visible: true,
      hidden: true,
    },
    BRAND: {
      label: 'Brand',
      visible: true,
      hidden: true,
    },
    MFG_BATCH_NO: {
      label: 'MFG Batch Number #',
      visible: true,
      hidden: true,
    },
    MANUFACTURING_DATE: {
      label: 'Manufacturing Date',
      visible: true,
      hidden: true,
    },

  });
  const [showQCList, setShowQCList] = useState(false);
  const fixedColumns = ['SKU_CODE'];
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [batchDateSelectedIntervalDateRangeType, setBatchDateSelectedIntervalDateRangeType] = useState('');
  const [expiryDateSelectedIntervalDateRangeType, setExpiryDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const batchDataWithKey = () => data?.map((item) => ({
    ...item,
  }));

  const moreMenuItems = [
    {
      label: 'Certificate of Analysis',
      key: 'download_coa',
    },
  ];

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const batchesColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => {
          let qty = 0;
          for (let i = 0; i < record?.reserved_quantities?.length; i++) {
            qty += record?.reserved_quantities?.[i]?.reserved_qty;
          }
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          // eslint-disable-next-line prefer-const
          let shelfLifePct = Math.round(((shelfLife / record.expiry_days) * 100));
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.custom_batch_number ? record.custom_batch_number : record?.batch_number}`} />
                </div>
                <div className="mobile-list__card_header-right">
                  <div className="mobile-list__card__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
                    {record?.is_rejected_batch ? 'Bad' : 'Good'}
                  </div>
                  {record?.pending_quality_check_info?.quality_check_id && (
                    <div className="mobile-list__card__status" style={{ backgroundColor: 'rgb(200, 200, 200)' }}>
                      Pending for QC
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <Link
                    to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                  >
                    <PRZText
                      text={`#${record?.internal_sku_code}`}
                      className="mobile-list__card_item-details"
                    />
                  </Link>
                  {record?.product_sku_name && (
                    <div className="mobile-list__card_item-name_wrapper">
                      <Link
                        to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                      >
                        <PRZText
                          className="mobile-list__card_item-name"
                          text={record?.product_sku_name}
                        />
                      </Link>
                    </div>
                  )}

                  {record?.product_category_info?.category_path?.length > 0 && (
                    <Tooltip
                      title={(
                        <PRZText
                          className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                          text={record?.product_category_info?.category_path.join(' / ')}
                        />
                      )}
                      color="white"
                      trigger={['click']}
                    >
                      {record?.product_category_info && (
                        <div
                          className="mobile-list__card_item__category__wrapper"
                        >
                          {' '}
                          {`.../${record?.product_category_info?.product_category_name}`}
                        </div>
                      )}
                    </Tooltip>
                  )}

                  {user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active && record?.batch_barcode && (
                    <PRZText className="mobile-list__card_item-details" text={`Barcode - ${record?.batch_barcode}`} />
                  )}

                </div>
                <div className="mobile-list__card_body-right">
                  {record?.product_type?.toUpperCase() !== 'SERVICE' && (
                    <Tooltip
                      color="white"
                      placement="top"
                      title={(
                        <PRZText className="mobile-list__card_item__tooltip_text-color" text="Available Stock" />
                      )}
                    >
                      <PRZText
                        text={`${QUANTITY(record?.available_qty - qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
                        className="mobile-list__card_item-details"
                      />
                    </Tooltip>
                  )}
                </div>
              </div>

              <PRZText
                text={`Location - ${record?.tenant_name} (${record?.department_name})`}
                className="mobile-list__card_item-details"
              />

              <Divider className="mobile-list__card_divider" />

              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  {shelfLife !== 0 ? (
                    <div>
                      {record?.expiry_date === '2099-01-01'
                        ? <Tag color="green">No expiry</Tag> : (
                          <div className="product-batch-shelf-life">
                            <div
                              className="progress-line__wrapper"
                              style={{
                                width: '80px',
                                backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                              }}
                            >
                              <div
                                className="progress-line"
                                style={{
                                  width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                                  backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                                }}
                              />
                            </div>
                            <span>
                              {`${shelfLife} Days (${shelfLifePct > 100 ? 100 : shelfLifePct}%)`}
                            </span>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className="inventory-lookup__expired-row">
                      Expired on&nbsp;
                      {dayjs(record?.expiry_date).format('DD/MMM/YYYY')}
                    </div>
                  )}
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedProduct(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'SKU#',
        render: (record) => (
          <div className="associated-entity min-width-50">
            <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
              #
              {record?.internal_sku_code}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'left',
        className: !visibleColumns?.SKU_CODE?.visible ? 'display-none' : '',
      },
      {
        title: 'INTERNAL SKU#',
        render: (record) => (
          <div className="associated-entity min-width-100">
            <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
              {record?.ref_product_code}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.INTERNAL_SKU_CODE?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            {record?.tenant_name}
            <H3Text text={record?.department_name} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns?.BUSINESS_UNIT?.visible ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'PRODUCT',
        render: (record) => (
          <div className="batch-product__wrapper min-width-70">
            <div>{record?.product_sku_name}</div>
            {record?.product_category_info?.category_path && (
              <Tooltip
                overlay={(
                  <div className="product-category__tooltip">
                    {record.product_category_info.category_path.join(' / ')}
                  </div>
                )}
                color="rgb(234, 242, 254)"
              >
                {' '}
                {/* Tooltip wrapping the div */}
                <div
                  className="product-category__wrapper"
                >
                  {/* Displaying only the last category name with ellipsis if path is long */}
                  {record?.product_category_info ? (
                    `.../${record?.product_category_info?.product_category_name}`
                  ) : (
                    ''
                  )}
                </div>
              </Tooltip>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PRODUCT_NAME?.visible ? 'display-none' : '',
      },
      {
        title: 'ON HAND',
        render: (record) => (
          <div className="min-width-50">
            {`${QUANTITY(record?.available_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ON_HAND_STOCK?.visible ? 'display-none' : '',
      },
      {
        title: 'RESERVED',
        render: (record) => (
          <div className="min-width-70">
            {`${QUANTITY(record?.reserved_quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.RESERVED_STOCK?.visible ? 'display-none' : '',
      },
      // {
      //   title: 'RESERVED',
      //   responsive: ['sm', 'md', 'lg', 'xxl'],
      //   render: (text, record) => {
      //     let qty = 0;
      //     for (let i = 0; i < record?.reserved_quantities?.length; i++) {
      //       qty += record?.reserved_quantities?.[i]?.reserved_qty;
      //     }
      //     return (
      //       <React.Fragment>
      //         {qty > 0 ? (
      //           <Popconfirm
      //             title="Reservation Details"
      //             className="mrp-reservation__tooltip-wrapper"
      //             description={(
      //               <div>
      //                 {record?.reserved_quantities?.map((i) => (
      //                   <div className="mrp-reservation__tooltip">
      //                     <div className="mrp-reservation__tooltip-info">
      //                       <Link to={`/production/manufacturing-orders/view/${i?.entity_id}`}>
      //                         {i?.entity_number}
      //                       </Link>
      //                     </div>
      //                     <div
      //                       className="mrp-reservation__tooltip-info"
      //                       style={{ marginRight: '0px', minWidth: 'auto' }}
      //                     >
      //                       {`${QUANTITY(i?.reserved_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}
      //                     </div>
      //                   </div>
      //                 ))}
      //               </div>
      //             )}
      //             okText="Got It!"
      //             showCancel={false}
      //           >
      //             <div className="product-batch-available-txn-stock" style={{ cursor: 'pointer' }}>
      //               <span>
      //                 {QUANTITY(qty || '0', record?.uom_info?.precision)}
      //                 {' '}
      //                 {record?.uom_info?.uqc?.toProperCase()}
      //               </span>
      //               &nbsp;
      //               <FontAwesomeIcon icon={faInfoCircle} />
      //             </div>
      //           </Popconfirm>
      //         ) : '-'}
      //       </React.Fragment>
      //     );
      //   },
      //   className: !visibleColumns?.RESERVED_STOCK?.visible ? 'display-none' : '',
      // },
      {
        title: 'AVAILABLE STOCK',
        render: (record) => {
          let qty = 0;
          for (let i = 0; i < record?.reserved_quantities?.length; i++) {
            qty += record?.reserved_quantities?.[i]?.reserved_qty;
          }
          return (
            <div className="min-width-115">
              {`${QUANTITY(record?.available_qty - qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.AVAILABLE_STOCK?.visible ? 'display-none' : '',
      },
      {
        title: 'BATCH #',
        editable: true,
        render: (record) => (
          <div className="column-number__wrapper min-width-70">
            {record?.custom_batch_number ? record.custom_batch_number : record?.batch_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BATCH_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'LOT #',
        editable: true,
        render: (record) => <div className="min-width-50">{record?.lot_number ? record?.lot_number : '-'}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOT_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'VENDOR',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {record?.seller_id ? (
              <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                <div className="company-name">
                  {record?.seller_name}
                </div>
              </Link>
            ) : '-'}
          </div>
        ),
        className: !visibleColumns?.VENDOR?.visible ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'AR NUMBER',
        editable: true,
        render: (record) => <div className="min-width-85">{record?.ar_number ? record?.ar_number : '-'}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.AR_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'QUALITY',
        render: (text, record) => (
          <div className="column-quality__wrapper min-width-70">
            <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
              {record?.is_rejected_batch ? 'Bad' : 'Good'}
            </div>
            {record?.pending_quality_check_info?.quality_check_id && (
              <div className="qr__status" style={{ backgroundColor: 'rgb(200, 200, 200)', marginTop: '5px' }}>
                Pending for QC
              </div>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BATCH_QUALITY?.visible ? 'display-none' : '',
      },
      {
        title: 'EXPIRY',
        render: (record) => {
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          // eslint-disable-next-line prefer-const
          let shelfLifePct = Math.round(((shelfLife / record.expiry_days) * 100));

          return (
            <div className="min-width-70">
              {
                shelfLife !== 0 ? (
                  <div>
                    <div>
                      {record?.expiry_date === '2099-01-01'
                        ? <Tag color="green">No expiry</Tag> : (
                          <div className="product-batch-shelf-life">
                            <div
                              className="progress-line__wrapper"
                              style={{
                                width: '80px',
                                backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                              }}
                            >
                              <div
                                className="progress-line"
                                style={{
                                  width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                                  backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                                }}
                              />
                            </div>
                            <span>
                              {`${shelfLife} Days (${shelfLifePct > 100 ? 100 : shelfLifePct}%)`}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                ) : (
                  <div className="inventory-lookup__expired-row">
                    Expired on&nbsp;
                    {dayjs(record?.expiry_date).format('DD/MMM/YYYY')}
                  </div>
                )
              }
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.EXPIRY_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'WAREHOUSE BIN',
        editable: true,
        render: (record) => (
          <div className="bin__wrapper min-width-115">
            {record?.inventory_location_path}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'BARCODE',
        editable: true,
        render: (record) => (
          <div className="bin__wrapper min-width-70">
            {record?.batch_barcode}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        onCell: (record) => ({
          record,
          inputType: 'text',
          dataIndex: 'barcode',
          title: 'barcode',
          // editing: !!((record.batch_id === editingRow || !record.batch_id)),
        }),
        className: (!visibleColumns?.BARCODE?.visible || !user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active) ? 'display-none' : '',
      },
      {
        title: 'CATEGORY',
        render: (text, record) => (
          <div className="min-width-70">
            {(record.product_type !== 'STORABLE' && record.product_type) && (
              <div className="qr__status" style={{ backgroundColor: Helpers.getProductType(record.product_type)?.color }}>{Helpers.getProductType(record.product_type)?.text}</div>
            )}
            {(record.product_category) && (
              <div className="qr__status" style={{ backgroundColor: '#3aa5a6' }}>
                {record.product_category}
              </div>
            )}
            {(record.is_marketplace_product) && (
              <div className="qr__status" style={{ backgroundColor: '#f58428' }}>
                Marketplace
              </div>
            )}
          </div>

        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CATEGORY?.visible ? 'display-none' : '',
      },
      {
        title: 'REORDER LEVEL',
        render: (record) => (
          <div className="min-width-100">
            {`${QUANTITY(record?.threshold_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MIN_QTY?.visible ? 'display-none' : '',
      },
      {
        title: 'TAX',
        render: (record) => (
          <div className="min-width-50">
            {`${record?.tax_info?.tax_value}%`}
          </div>
        ),
        className: !visibleColumns?.TAX?.visible ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'CREATED BY',
        render: (record) => (
          <div className="min-width-85">
            <div className="column-date">
              {dayjs(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : '')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_BY?.visible ? 'display-none' : '',
      },
      {
        title: 'BATCH INWARD DATE',
        editable: true,
        render: (record) => (
          <div className="column-date min-width-115">
            {record?.batch_inward_date ? dayjs(record?.batch_inward_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BATCH_INWARD_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'ROLL NUMBER #',
        editable: true,
        render: (record) => (
          <div className="min-width-100">
            {record?.roll_no ? record?.roll_no : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ROLL_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'COST PRICE',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-85">
            {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view cost price" /> : MONEY(record?.cost_price)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.COST_PRICE?.visible ? 'display-none' : '',
      },
      {
        title: 'FREIGHT COST',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-100">
            {MONEY(record?.freight_cost)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.FREIGHT_COST?.visible ? 'display-none' : '',
      },
      {
        title: 'OTHER COST',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-85">
            {MONEY(record?.other_cost)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.OTHER_COST?.visible ? 'display-none' : '',
      },
      {
        title: 'LANDED COST',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-100">
            {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view landed cost" /> : MONEY(record?.landed_cost)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LANDED_COST?.visible ? 'display-none' : '',
      },
      {
        title: 'SELLING PRICE',
        editable: true,
        render: (record) => (
          <div className="column-date min-width-115">
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view selling price" /> : MONEY(record?.selling_price)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SELLING_PRICE?.visible ? 'display-none' : '',
      },
      {
        title: 'MRP',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-50">
            {MONEY(record?.mrp)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MRP?.visible ? 'display-none' : '',
      },
      {
        title: 'MARGIN',
        editable: true,
        render: (record) => (
          <div className="min-width-70">
            {record?.margin ? `${parseFloat(Number(record?.margin).toFixed(DEFAULT_CUR_ROUND_OFF))}%` : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MARGIN?.visible ? 'display-none' : '',
      },
      {
        title: 'QC NUMBER',
        render: (record) => (
          <div className="associated-entity min-width-85">
            <Link to={`/quality/quality-checks?page=1&limit=10&keyword=${record?.pending_quality_check_info?.qc_number}`} target="_blank">
              {record?.pending_quality_check_info?.qc_number || '-'}
            </Link>
          </div>
        ),
        className: !visibleColumns?.QC_NUMBER?.visible ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'LAST QC DATE',
        editable: true,
        render: (record) => (
          <div className="column-date min-width-100">
            {record?.last_qc_date ? dayjs(record?.last_qc_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LAST_QC_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'NEXT QC DATE',
        editable: true,
        render: (record) => (
          <div className="column-date min-width-100">
            {record?.next_qc_date ? dayjs(record?.next_qc_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.NEXT_QC_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'BRAND',
        editable: true,
        render: (record) => (
          <div className="min-width-50">
            {record?.brand ? record?.brand : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BRAND?.visible ? 'display-none' : '',
      },
      {
        title: 'MFG BATCH NO #',
        editable: true,
        render: (record) => <div className="min-width-115">{record?.mfg_batch_no ? record?.mfg_batch_no : '-'}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MFG_BATCH_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'MANUFACTURING DATE',
        editable: true,
        render: (record) => (
          <div className="min-width-150">
            {record?.manufacturing_date ? Helpers.batchDateFormatter(record?.manufacturing_date, record?.manufacturing_date_format) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MANUFACTURING_DATE?.visible ? 'display-none' : '',
      },
    ];

    // for adding columns of custom fields
    if (customFieldsProps?.data?.success) {
      customFieldsProps?.data?.batch_custom_fields?.filter((item) => item?.is_active)?.map((custom) => {
        columns.push({
          title: custom?.field_name?.toUpperCase(),
          editable: true,
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields
                customField={record?.custom_fields?.filter((subItem) => subItem.cf_id === custom?.cf_id)?.[0]}
              />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom?.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }

    columns.push({
      title: '',
      className: 'list__actions-column',
      dataIndex: 'operation',
      fixed: 'right',
      render: (_, record) => {
        const margeCustomFields = customFieldsProps?.data?.batch_custom_fields?.map((field) => {
          // Find matching field in record?.custom_fields
          const matchingField = record?.custom_fields?.find((cf) => cf.cf_id === field.cf_id);

          // If a match is found, override field_value; otherwise, keep the original field
          return {
            ...field,
            field_value: matchingField ? matchingField.field_value : field.field_value,
          };
        });
        return (
          record?.batch_id ? (
            <div className="list__actions">
              {record?.mo_adjustment_id && (dayjs(dayjs(record.created_at).format('YYYY-MM-DD')).isAfter('2024-01-01', 'day')) && (
                <div
                  className="batch-bmr-button"
                  onClick={() => downloadDocument({
                    url: `${constants.MO}/bmr_report?mo_adjustment_id=${record?.mo_adjustment_id}`,
                    document_type: 'BATCH_MANUFACTURING_RECORD',
                    document_number: record?.batch_number,
                    key: uuidv4(),
                  })}
                >
                  <H3Text
                    text={(
                      <Fragment>
                        <FontAwesomeIcon
                          icon={faDownload}
                          className="action-button-text"
                        />
                        &nbsp; BMR
                      </Fragment>
                    )}
                    className="list__actions-button"
                  />
                </div>
              )}
              <div
                className="list__actions-button"
                onClick={() => {
                  setEditDrawer(true);
                  setLineDate(record);
                  setUpdatedBatchNumber(record.custom_batch_number);
                  setUpdatedMRP(record.mrp);
                  setUpdatedSellingPrice(record.selling_price || 0);
                  setUpdatedCostPrice(record.cost_price);
                  setSelectedInventoryLocation(record.inventory_location_id);
                  setSelectedInventoryLocationName(record.inventory_location_path);
                  setSelectedTenantDepartment(record.tenant_department_id);
                  setUpdatedLotNumber(record.lot_number);
                  setUpdatedBatchQuality(record.is_rejected_batch);
                  setUpdatedExpiryDate(toISTDate(record.expiry_date));
                  setUpdatedArNumber(record.ar_number);
                  setUpdatedBarcode(record.batch_barcode);
                  setUpdatedMfgDate(record.manufacturing_date ? toISTDate(record.manufacturing_date) : '');
                  setUpdatedMfgBatchNumber(record.mfg_batch_no);
                  setUpdatedBrand(record.brand);
                  setUpdatedLandesCost(record.landed_cost);
                  setUpdatedOtherCost(record.other_cost);
                  setUpdatedFreightCost(record.freight_cost);
                  setUpdatedNextQcDate(record.next_qc_date ? toISTDate(record.next_qc_date) : '');
                  setUpdatedLastQcDate(record.last_qc_date ? toISTDate(record.last_qc_date) : '');
                  setUpdatedRollNumber(record.roll_no);
                  setUpdatedCustomFields(CustomFieldHelpers.getCfStructure((margeCustomFields || []), true));
                  // api call with callback goes here
                }}
              >
                <FontAwesomeIcon icon={faPen} />
              </div>
              {user?.tenant_info?.quality_control_config && Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS,
                Helpers.permissionTypes.CREATE, user) && (
                  <Tooltip
                    title={
                      record?.is_available_for_retest ? 'Send for Quality Retest' : 'Already sent for Quality Retest or QC Rule not available!'
                    }
                  >
                    <Popconfirm
                      title="Send this batch for quality retest?"
                      description={record?.sample_percentage ? (
                        <div>
                          <Checkbox
                            checked={record?.is_sample_collected}
                            onChange={(e) => {
                              const copyData = JSON.parse(JSON.stringify(data));
                              for (let i = 0; i < copyData?.length; i++) {
                                if (copyData[i].key === record.key) {
                                  copyData[i].is_sample_collected = e.target.checked;
                                }
                              }
                              setData(copyData);
                            }}
                          >
                            Sample to be Collected?
                          </Checkbox>
                        </div>
                      ) : ''}
                      disabled={!record?.is_available_for_retest}
                      onConfirm={() => {
                        retestQualityCheck({ batch_ids: [record.batch_id], loadingHandler: getBatchesLoading, sample_to_be_collected: record.is_sample_collected }, () => {
                          setCall(!call);
                        });
                      }}
                    >
                      <div className="list__actions-button">
                        {/* <ExperimentOutlined style={{ color: !record?.is_available_for_retest ? '#d3d3d3' : '#2d7cf7' }} /> */}
                        <FontAwesomeIcon icon={faFlask} style={{ color: !record?.is_available_for_retest ? '#d3d3d3' : '#2d7cf7' }}/>
                      </div>
                    </Popconfirm>
                  </Tooltip>
                )}
              <Dropdown
                className="list__actions-button"
                menu={{
                  items: moreMenuItems,
                  onClick: ({ key }) => {
                    switch (key) {
                    case 'download_coa':
                      setLineDate(record);
                      setShowQCList(true);
                      break;
                    default:
                      break;
                    }
                  },
                }}
                arrow
                trigger="click"
              >
                <span onClick={(e) => e.preventDefault()}>
                  <FontAwesomeIcon
                    icon={faDownload}
                    className="action-button-text"
                  />
                </span>
              </Dropdown>

            </div>
          ) : null
        );
      },
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
    });
    return columns.filter((item) => !item.hidden);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit')) || limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'org_id',
        filter_value: user?.tenant_info?.org_id,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'pending_for_qc_retest',
        filter_value: Boolean(Helpers.getValueFromUrl('pending_for_qc_retest')) || false,
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'isExpired',
        filter_value: Boolean(Helpers.getValueFromUrl('isExpired')) || '',
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant')
          ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => Number(item))
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'quantity_class',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'expiry_status',
        filter_value: Helpers.getValueFromUrl('expiry_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'maxCostPrice',
        filter_value: Number(Helpers.getValueFromUrl('maxCostPrice')) || 0,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'minCostPrice',
        filter_value: Number(Helpers.getValueFromUrl('minCostPrice')) || 0,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'maxMRP',
        filter_value: Number(Helpers.getValueFromUrl('maxMRP')) || 0,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'categories',
        filter_value:
          Helpers.getValueFromUrl('categories') && Helpers.getValueFromUrl('categories') !== 'null'
            ? Helpers.getValueFromUrl('categories')?.split(',')?.filter(Boolean)?.map(Number)
            : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'minMRP',
        filter_value: Number(Helpers.getValueFromUrl('minMRP')) || 0,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('batch_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('batch_date_type') || '',
      },
      {
        filter_key: 'sortOrderByProductName',
        filter_value: Helpers.getValueFromUrl('sortOrderByProductName') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'sortOrderByExpiryDate',
        filter_value: Helpers.getValueFromUrl('sortOrderByExpiryDate') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'expiryStartDate',
        filter_value: Number(Helpers.getValueFromUrl('expiryStartDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('expiry_date_type') || '',
      },
      {
        filter_key: 'expiryEndDate',
        filter_value: Number(Helpers.getValueFromUrl('expiryEndDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('expiry_date_type') || '',
      },
      {
        filter_key: 'isRejectedBatch',
        filter_value:
          Helpers.getValueFromUrl('isRejectedBatch') === ''
            ? ''
            : Helpers.getValueFromUrl('isRejectedBatch') === 'true'
              ? true
              : Helpers.getValueFromUrl('isRejectedBatch') === 'false'
                ? false
                : '',
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'sortOrderByBatch',
        filter_value: Helpers.getValueFromUrl('sortOrderByBatch') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'inventory_location_id',
        filter_value: Number(Helpers.getValueFromUrl('inventory_location_id')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'sortOrder',
        filter_value: Helpers.getValueFromUrl('sortOrder') || 'ASC',
        filter_type: filterTypeEnums.STRING,
      },
    ];

    if (Helpers.getValueFromUrl('is_pre_fill') !== 'not') {
      appliedFiltersFromURL.forEach((item) => {
        if (item.filter_key === 'department_id') {
          item.filter_value = Number(Helpers.getValueFromUrl('department_id')) || null;
        }

        if (item.filter_key === 'quantity_class') {
          item.filter_value = Helpers.getValueFromUrl('quantity_class') || '';
        }
      });
    }

    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const initialFilters = [{
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'org_id',
      filter_value: user?.tenant_info?.org_id,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'pending_for_qc_retest',
      filter_value: false,
      filter_type: filterTypeEnums.BOOLEAN,
    },
    {
      filter_key: 'isExpired',
      filter_value: '',
      filter_type: filterTypeEnums.BOOLEAN,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'department_id',
      filter_value: null,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'quantity_class',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'expiry_status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'maxCostPrice',
      filter_value: 0,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'minCostPrice',
      filter_value: 0,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'maxMRP',
      filter_value: 0,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'categories',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'minMRP',
      filter_value: 0,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'startDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'endDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'sortOrderByProductName',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'sortOrderByExpiryDate',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'expiryStartDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'expiryEndDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'isRejectedBatch',
      filter_value: '',
      filter_type: filterTypeEnums.BOOLEAN,
    },
    {
      filter_key: 'sortOrderByBatch',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'inventory_location_id',
      filter_value: '',
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'sortOrder',
      filter_value: 'ASC',
      filter_type: filterTypeEnums.STRING,
    },
    ];

    if (Helpers.getValueFromUrl('is_pre_fill') !== 'not') {
      initialFilters.forEach((item) => {
        if (item.filter_key === 'department_id') {
          item.filter_value = Helpers.getDepartmentId(user) || user?.tenant_info?.department_id;
        }
        if (item.filter_key === 'quantity_class') {
          item.filter_value = 'POSITIVE_QUANTITY_BATCHES';
        }
      });
    }

    return initialFilters;
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PRODUCT_BATCHES,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      setVisibleColumns(columns);
      setSelectedFilterView(systemDefaultUserView);
    }
  }, []);

  useEffect(() => {
    if (user?.tenant_info?.org_id && savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _batchDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _batchStartDate = '';
        let _batchEndDate = '';

        if (_batchDateRangeType === '' || _batchDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_batchDateRangeType);
          const [start, end] = date;

          _batchStartDate = start;
          _batchEndDate = end;
          filterValue.startDate = _batchStartDate;
          filterValue.endDate = _batchEndDate;
        }

        filterValue.batchDateRangeType = _batchDateRangeType;

        const _expiryDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'expiryStartDate', valueOnly: false }).date_range_type;

        let _expiryStartDate = '';
        let _expiryEndDate = '';

        if (_expiryDateRangeType === '' || _expiryDateRangeType === dateRangePresets.CUSTOM) {
        // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_expiryDateRangeType);
          const [start, end] = date;

          _expiryStartDate = start;
          _expiryEndDate = end;
          filterValue.expiryStartDate = _expiryStartDate;
          filterValue.expiryEndDate = _expiryEndDate;
        }
        filterValue.expiryDateRangeType = _expiryDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);

      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setPendingForQcRetest(tempFilterValues.pending_for_qc_retest);
        setIsExpired(tempFilterValues.isExpired);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedDepartment(tempFilterValues.department_id);
        setAvailableStocks(tempFilterValues.quantity_class);
        setExpiryStatus(tempFilterValues.expiry_status);
        setMaxCostPrice(tempFilterValues.maxCostPrice);
        setMinCostPrice(tempFilterValues.minCostPrice);
        setMaxMRP(tempFilterValues.maxMRP);
        setSelectedCategory(tempFilterValues.categories);
        setMinMRP(tempFilterValues.minMRP);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setBatchDateSelectedIntervalDateRangeType(tempFilterValues.batchDateRangeType);
        setSortOrderByProductName(tempFilterValues.sortOrderByProductName);
        setSortOrderByExpiryDate(tempFilterValues.sortOrderByExpiryDate);
        setExpiryStartDate(tempFilterValues.expiryStartDate);
        setExpiryEndDate(tempFilterValues.expiryEndDate);
        setExpiryDateSelectedIntervalDateRangeType(tempFilterValues.expiryDateRangeType);
        // setSelectedFilterTenantDepartment(Helpers.getTenantDepartmentId(user));
        setIsRejectedBatch(tempFilterValues.isRejectedBatch);
        setSelectedFilterInventoryLocation(tempFilterValues.inventory_location_id);
        setSortOrder(tempFilterValues.sortOrder || 'ASC');
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (org) {
      const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      const newColumns = {};
      Object.keys(columns).map((key) => {
        switch (key) {
        case 'SKU_CODE':
          columns[key].hidden = false;
          break;
        case 'INTERNAL_SKU_CODE':
          columns[key].hidden = false;
          break;
        case 'PRODUCT_NAME':
          columns[key].hidden = false;
          break;
        case 'BUSINESS_UNIT':
          columns[key].hidden = false;
          break;
        case 'DEPARTMENT':
          columns[key].hidden = false;
          break;
        case 'BATCH_NUMBER':
          columns[key].hidden = false;
          break;
        case 'LOT_NUMBER':
          columns[key].hidden = !batchConfig?.lot_number_is_enabled;
          break;
        case 'AR_NUMBER':
          columns[key].hidden = !batchConfig?.ar_number_is_enabled;
          break;
        case 'VENDOR':
          columns[key].hidden = !batchConfig?.seller_name_is_enabled;
          break;
        case 'BATCH_QUALITY':
          columns[key].hidden = false;
          break;
        case 'BARCODE':
          columns[key].hidden = !batchConfig?.batch_barcode_is_enabled;
          break;
        case 'COST_PRICE':
          columns[key].hidden = false;
          break;
        case 'SELLING_PRICE':
          columns[key].hidden = !batchConfig?.selling_price_is_enabled;
          break;
        case 'MRP':
          columns[key].hidden = !batchConfig?.mrp_is_enabled;
          break;
        case 'CATEGORY':
          columns[key].hidden = false;
          break;
        case 'LOCATION':
          columns[key].hidden = false;
          break;
        case 'CREATED_BY':
          columns[key].hidden = false;
          break;
        case 'EXPIRY_DATE':
          columns[key].hidden = false;
          break;
        case 'TAX':
          columns[key].hidden = false;
          break;
        case 'MIN_QTY':
          columns[key].hidden = false;
          break;
        case 'ON_HAND_STOCK':
          columns[key].hidden = false;
          break;
        case 'RESERVED_STOCK':
          columns[key].hidden = false;
          break;
        case 'AVAILABLE_STOCK':
          columns[key].hidden = false;
          break;
        case 'BATCH_INWARD_DATE':
          columns[key].hidden = !batchConfig?.batch_barcode_is_enabled;
          break;
        case 'ROLL_NO':
          columns[key].hidden = !batchConfig?.roll_no_is_enabled;
          break;
        case 'NEXT_QC_DATE':
          columns[key].hidden = !batchConfig?.next_qc_date_is_enabled;
          break;
        case 'LAST_QC_DATE':
          columns[key].hidden = !batchConfig?.last_qc_date_is_enabled;
          break;
        case 'FREIGHT_COST':
          columns[key].hidden = !batchConfig?.freight_cost_is_enabled;
          break;
        case 'OTHER_COST':
          columns[key].hidden = !batchConfig?.other_cost_is_enabled;
          break;
        case 'LANDED_COST':
          columns[key].hidden = !batchConfig?.landed_cost_is_enabled;
          break;
        case 'MARGIN':
          columns[key].hidden = !batchConfig?.margin_is_enabled;
          break;
        case 'BRAND':
          columns[key].hidden = !batchConfig?.brand_is_enabled;
          break;
        case 'MFG_BATCH_NO':
          columns[key].hidden = !batchConfig?.mfg_batch_no_is_enabled;
          break;
        case 'MANUFACTURING_DATE':
          columns[key].hidden = !batchConfig?.manufacturing_date_is_enabled;
          break;
        default:
          // Handle default case
        }
        if (!columns[key].hidden) {
          newColumns[key] = columns[key];
        }
      });
      setVisibleColumns(newColumns);
    }
  }, [org]);

  useEffect(() => {
    if (customFieldsProps?.data?.success) {
      const customFields = customFieldsProps?.data?.batch_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active && !item?.is_system_field)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-inventory-lookup'))?.[customField.cf_id]?.visible,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const pushParamsToUrl = (page, lim, orgId, currentTenant, order, exp, word, startDateEpoch, endDateEpoch, department, expiryStartDateEpoch, expiryEndDateEpoch, sortOrderbypdtname, sortOrderbyexpdate, sortOrderbybatchname, mincp, maxcp, minmrp, maxmrp, inventoryLocation, rej, category, expiryStatus, availableStock, qcRetest, batchDateSelectedIntervalDateRangeType, expiryDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '?tab=/product-batches';
    if (page) url += `&page=${page}`;
    if (lim) url += `&limit=${lim}`;
    if (orgId) url += `&org_id=${orgId}`;
    if (word) url += `&keyword=${word}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (department) url += `&department_id=${department}`;
    if (order) url += `&sortOrder=${order}`;
    if (sortOrderbypdtname) url += `&sortOrderByProductName=${sortOrderbypdtname}`;
    if (sortOrderbyexpdate) url += `&sortOrderByExpiryDate=${sortOrderbyexpdate}`;
    if (sortOrderbybatchname) url += `&sortOrderByBatch=${sortOrderbybatchname}`;
    if (exp) url += `&isExpired=${exp}`;
    if (startDateEpoch) url += `&startDate=${startDateEpoch}`;
    if (endDateEpoch) url += `&endDate=${endDateEpoch}`;
    // if (expTimeRange) url += `&exp_time_range=${expTimeRange}`;
    if (expiryStartDateEpoch) url += `&expiryStartDate=${expiryStartDateEpoch}`;
    if (expiryEndDateEpoch) url += `&expiryEndDate=${expiryEndDateEpoch}`;
    if (mincp) url += `&minCostPrice=${mincp}`;
    if (maxcp) url += `&maxCostPrice=${maxcp}`;
    if (minmrp) url += `&minMRP=${minmrp}`;
    if (maxmrp) url += `&maxMRP=${maxmrp}`;
    if (inventoryLocation) url += `&inventory_location_id=${inventoryLocation}`;
    if (rej === true || rej === false) url += `&isRejectedBatch=${rej}`;
    if (category) url += `&categories=${category}`;
    if (expiryStatus) url += `&expiry_status=${expiryStatus}`;
    if (availableStock) url += `&quantity_class=${availableStock}`;
    if (qcRetest) url += `&pending_for_qc_retest=${qcRetest}`;
    if (batchDateSelectedIntervalDateRangeType) url += `&batch_date_type=${batchDateSelectedIntervalDateRangeType}`;
    if (expiryDateSelectedIntervalDateRangeType) url += `&expiry_date_type=${expiryDateSelectedIntervalDateRangeType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, user?.tenant_info?.org_id, selectedTenant, sortOrder, isExpired, searchKeyword, startDate, endDate, selectedDepartment, expiryStartDate, expiryEndDate, sortOrderByProductName, sortOrderByExpiryDate, '', minCostPrice, maxCostPrice, minMRP, maxMRP, selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, expiryStatus, availableStocks, pendingForQcRetest, batchDateSelectedIntervalDateRangeType, expiryDateSelectedIntervalDateRangeType, selectedFilterView);
      getInventoryLocations(selectedFilterTenantDepartment || '', '', null, true, Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id, selectedDepartment?.toString() || Helpers.getValueFromUrl('department_id')?.toString());
      getCategories();
      let isRejectedBatchValuetemp = '';
      const isRejectedBatchValue = Helpers.getValueFromUrl('isRejectedBatch');
      if (isRejectedBatchValue === '') {
        isRejectedBatchValuetemp = '';
      } else if (isRejectedBatchValue === 'true') {
        isRejectedBatchValuetemp = true;
      } else if (isRejectedBatchValue === 'false') {
        isRejectedBatchValuetemp = false;
      }
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());

      const payload = {
        filters: {
          org_id: user?.tenant_info?.org_id,
          expiry_status: expiryStatus || Helpers.getValueFromUrl('expiry_status'),
          is_rejected_batch: isRejectedBatch || isRejectedBatchValuetemp,
          inventory_location_id: selectedFilterInventoryLocation || Helpers.getValueFromUrl('inventory_location_id'),
          expiry_date_from_date: expiryStartDate || Helpers.getValueFromUrl('expiryStartDate'),
          expiry_date_to_date: expiryEndDate || Helpers.getValueFromUrl('expiryEndDate'),
          product_category_ids: selectedCategory.join(','),
          tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ)?.join(','),
          created_date_from: startDate || Helpers.getValueFromUrl('startDate'),
          created_date_to: endDate || Helpers.getValueFromUrl('endDate'),
          search: searchKeyword || Helpers.getValueFromUrl('keyword'),
          quantity_class: availableStocks,
          department_id: selectedDepartment || Helpers.getValueFromUrl('department_id'),
          is_expired: isExpired || Helpers.getValueFromUrl('isExpired'),
          mrp_from: minMRP || Helpers.getValueFromUrl('minMRP'),
          mrp_to: maxMRP || Helpers.getValueFromUrl('maxMRP'),
          cost_price_from: minCostPrice || Helpers.getValueFromUrl('minCostPrice'),
          cost_price_to: maxCostPrice || Helpers.getValueFromUrl('maxCostPrice'),
          pending_for_retest: pendingForQcRetest || Helpers.getValueFromUrl('pending_for_qc_retest'),
        },
        order_bys: {
          order_by_product_name: sortOrderByProductName || Helpers.getValueFromUrl('sortOrderByProductName'),
          order_by_expiry_date: sortOrderByExpiryDate || Helpers.getValueFromUrl('sortOrderByExpiryDate'),
        },
        sort_order: sortOrder || Helpers.getValueFromUrl('sortOrder'), // ASC OR DESC
        page: currentPage || Helpers.getValueFromUrl('page'),
        limit: limit || Helpers.getValueFromUrl('limit'),

      };
      getBatches(payload, (_data) => setData(_data.data?.batches?.map((item) => ({
        ...item,
        key: item?.batch_id,
        is_sample_collected: false,
      }))));
    }
  }, [currentPage, limit, user?.tenant_info?.org_id, selectedTenant, startDate, endDate, selectedDepartment, expiryStartDate, expiryEndDate, sortOrder, isExpired, sortOrderByProductName, sortOrderByExpiryDate, '', minCostPrice, maxCostPrice, minMRP, maxMRP, selectedTenantDepartment, selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, expiryStatus, call, availableStocks, pendingForQcRetest, batchDateSelectedIntervalDateRangeType, expiryDateSelectedIntervalDateRangeType]);

  // Dwonload Product Batches list

  const findCategoryNameById = (categories, id) => {
    if (!categories) return null; // Ensure categories is not undefined
    for (const category of categories) {
      if (category.product_category_id === id) {
        return category.product_category_name;
      }
      if (category.sub_categories) {
        const subCategoryName = findCategoryNameById(category.sub_categories, id);
        if (subCategoryName) {
          return subCategoryName;
        }
      }
    }
    return null; // Return null if no matching category is found
  };

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const stringsString = stringsArray.join(',');
    let isRejectedBatchValuetemp = '';
    const isRejectedBatchValue = Helpers.getValueFromUrl('isRejectedBatch');
    if (isRejectedBatchValue === '') {
      isRejectedBatchValuetemp = '';
    } else if (isRejectedBatchValue === 'true') {
      isRejectedBatchValuetemp = true;
    } else if (isRejectedBatchValue === 'false') {
      isRejectedBatchValuetemp = false;
    }
    const payload = {
      filters: {
        org_id: user?.tenant_info?.org_id,
        expiry_status: expiryStatus || Helpers.getValueFromUrl('expiry_status'),
        is_rejected_batch: isRejectedBatch || isRejectedBatchValuetemp,
        inventory_location_id: selectedFilterInventoryLocation || Helpers.getValueFromUrl('inventory_location_id'),
        expiry_date_from_date: expiryStartDate || Helpers.getValueFromUrl('expiryStartDate'),
        expiry_date_to_date: expiryEndDate || Helpers.getValueFromUrl('expiryEndDate'),
        product_category: selectedCategory?.join(','),
        tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ)?.join(','),
        created_date_from: startDate || Helpers.getValueFromUrl('startDate'),
        created_date_to: endDate || Helpers.getValueFromUrl('endDate'),
        search: searchKeyword || Helpers.getValueFromUrl('keyword'),
        quantity_class: availableStocks || Helpers.getValueFromUrl('availableStocks'),
        department_id: selectedDepartment || Helpers.getValueFromUrl('department_id'),
        is_expired: isExpired || Helpers.getValueFromUrl('isExpired'),
        mrp_from: minMRP || Helpers.getValueFromUrl('minMRP'),
        mrp_to: maxMRP || Helpers.getValueFromUrl('maxMRP'),
        cost_price_from: minCostPrice || Helpers.getValueFromUrl('minCostPrice'),
        cost_price_to: maxCostPrice || Helpers.getValueFromUrl('maxCostPrice'),
      },
      columns: stringsString,
      emails: selectedEmails,
      type: 'send_email',
      order_bys: {
        order_by_product_name: sortOrderByProductName || Helpers.getValueFromUrl('sortOrderByProductName'),
        order_by_expiry_date: sortOrderByExpiryDate || Helpers.getValueFromUrl('sortOrderByExpiryDate'),
      },
      sort_order: sortOrder || Helpers.getValueFromUrl('sortOrder'), // ASC OR DESC
      user_id: user?.user_id,
    };

    if (!downloadProductBatchesListLoading) {
      downloadProductBatchesList(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  const isFieldValid = (isEnabled, isMandatory, value) => {
    // If the field is enabled and mandatory, check if the value is valid

    if (isEnabled && isMandatory) {
      return !(value === undefined || value === '' || value === 0 || value === null);
    }
    // If the field is not enabled or not mandatory, it's considered valid
    return true;
  };

  function validateBatchDetailsSimple(config, batchCheck) {
    // Helper function to check if a field is missing when it's mandatory
    if (
      !isFieldValid(config.cost_price_is_enabled, config.cost_price_is_mandatory, Number(batchCheck.cost_price))
      || !isFieldValid(config.custom_batch_number_is_enabled, config.custom_batch_number_is_mandatory, batchCheck.custom_batch_number)
      || !isFieldValid(config.lot_number_is_enabled, config.lot_number_is_mandatory, Number(batchCheck.lot_number))
      || !isFieldValid(config.selling_price_is_enabled, config.selling_price_is_mandatory, Number(batchCheck.selling_price))
      || !isFieldValid(config.mrp_is_enabled, config.mrp_is_mandatory, Number(batchCheck.mrp))
      || !isFieldValid(config.batch_barcode_is_enabled, config.batch_barcode_is_mandatory, batchCheck.batch_barcode)
      || !isFieldValid(config.ar_number_is_enabled, config.ar_number_is_mandatory, batchCheck.ar_number)
      || !isFieldValid(config.roll_no_is_enabled, config.roll_no_is_mandatory, batchCheck.roll_no)
      || !isFieldValid(config.next_qc_date_is_enabled, config.next_qc_date_is_mandatory, batchCheck.next_qc_date)
      || !isFieldValid(config.last_qc_date_is_enabled, config.last_qc_date_is_mandatory, batchCheck.last_qc_date)
      || !isFieldValid(config.freight_cost_is_enabled, config.freight_cost_is_mandatory, Number(batchCheck.freight_cost))
      || !isFieldValid(config.other_cost_is_enabled, config.other_cost_is_mandatory, batchCheck.other_cost)
      || !isFieldValid(config.landed_cost_is_enabled, config.landed_cost_is_mandatory, Number(batchCheck.landed_cost))
      || !isFieldValid(config.margin_is_enabled, config.margin_is_mandatory, batchCheck.margin)
      || !isFieldValid(config.brand_is_enabled, config.brand_is_mandatory, batchCheck.brand)
      || !isFieldValid(config.mfg_batch_no_is_enabled, config.mfg_batch_no_is_mandatory, batchCheck.mfg_batch_no)
      || !isFieldValid(config.manufacturing_date_is_enabled, config.manufacturing_date_is_mandatory, batchCheck.manufacturing_date)
      // Include other conditions as needed
    ) {
      // If any field validation fails, return false
      return false;
    }
    // validation for mandatory custom fields
    for (const item of batchCheck?.custom_fields) {
      if (!isFieldValid(item?.is_active, item?.is_required, item?.field_value)) {
        return false;
      }
    }
    // If all batches pass validation, return true
    return true;
  }

  function isValidData(config) {
    if (config) {
      if (!isFieldValid(config.cost_price_is_enabled, config.cost_price_is_mandatory, Number(updatedCostPrice))
        || !isFieldValid(config.selling_price_is_enabled, config.selling_price_is_mandatory, Number(updatedSellingPrice))
        || !isFieldValid(config.landed_cost_is_enabled, config.landed_cost_is_mandatory, Number(updatedLandedCost))
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  // for update batch drawer
  const batchDrawerFields = () => {
    const initialColumns = [
      {
        title: 'Batch #',
        isEnabled: true,
        isRequired: batchConfig?.custom_batch_number_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                disabled={updateBatchesLoading}
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.custom_batch_number_is_mandatory && !updatedBatchNumber) ? 'orgFormInputError' : ''} `}
                value={updatedBatchNumber}
                onChange={(e) => setUpdatedBatchNumber(e.target.value)}
                label="Batch #"
                required={batchConfig?.custom_batch_number_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Lot #',
        isEnabled: batchConfig?.lot_number_is_enabled,
        isRequired: batchConfig?.lot_number_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.lot_number_is_mandatory && !updatedLotNumber) ? 'orgFormInputError' : ''} `}
                value={updatedLotNumber}
                onChange={(e) => setUpdatedLotNumber(e.target.value)}
                label="Lot #"
                required={batchConfig?.lot_number_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Quality',
        isEnabled: true,
        isRequired: false,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <div className="filter__title">Quality</div>
              <PRZSelect
                value={updatedBatchQuality ? 'Bad' : 'Good'}
                onChange={(value) => { setUpdatedBatchQuality(value); }}
                disabled={!user?.tenant_info?.permission?.allow_to_change_product_batches_quality}
              >
                <Option key={0} value={false}>
                  Good
                </Option>
                <Option key={1} value>
                  Bad
                </Option>
              </PRZSelect>
            </div>
          </div>
        ),
      },
      {
        title: 'Expiry',
        isEnabled: lineData?.expiry_date !== '2099-01-01',
        isRequired: true,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3Text
                text="Expiry"
                className="filter__title"
                required
              />
              <DatePicker
                value={updatedExpiryDate}
                disabledDate={(current) => dayjs().add(-1, 'month') >= current}
                onChange={(value) => {
                  setUpdatedExpiryDate(value);
                }}
                style={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '2px',
                  height: '28px',
                  width: '100%',
                  background: 'white',
                }}
                format="DD-MM-YYYY"
                className={(formSubmitted && !updatedExpiryDate) ? 'ShowInputError' : ''}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Warehouse Bin',
        isEnabled: true,
        isRequired: false,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <div className="filter__title">Warehouse Bin</div>
              <PRZSelect
                value={selectedInventoryLocationName}
                loading={getInventoryLocationsLoading}
                filterOption={false}
                showSearch
                onChange={(value) => {
                  setSelectedInventoryLocation(value);
                  setSelectedInventoryLocationName(inventoryLocations?.inventory_location?.find((item) => item.inventory_location_id == value)?.inventory_location_path);
                }}
                onSearch={(keyword) => {
                  getInventoryLocations(selectedFilterTenantDepartment || '', keyword, null, true, selectedTenant || Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id, selectedDepartment?.toString());
                }}
              >
                {
                  inventoryLocations?.inventory_location?.filter((item) => item?.is_active)?.map((item) => (
                    <Option
                      key={item?.inventory_location_id}
                      value={item?.inventory_location_id}
                    >
                      <H3Text text={item?.inventory_location_path} className="create-new-batch__location-item" />
                    </Option>
                  ))
                }
              </PRZSelect>

            </div>
          </div>
        ),
      },
      {
        title: 'Cost Price',
        isEnabled: true,
        isRequired: batchConfig?.cost_price_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.cost_price_is_mandatory && !updatedCostPrice) ? 'orgFormInputError' : ''} `}
                value={updatedCostPrice}
                onChange={(e) => setUpdatedCostPrice(e.target.value)}
                label="Cost Price"
                required={batchConfig?.cost_price_is_mandatory}
                hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
                popOverMessage="You don't have access to view/edit cost price"
              />
            </div>
          </div>
        ),
      },
      {
        title: 'MRP',
        isEnabled: batchConfig?.mrp_is_enabled,
        isRequired: batchConfig?.mrp_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.mrp_is_mandatory && !updatedMRP) ? 'orgFormInputError' : ''} `}
                value={updatedMRP}
                onChange={(e) => setUpdatedMRP(e.target.value)}
                label="MRP"
                required={batchConfig?.mrp_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Barcode',
        isEnabled: batchConfig?.batch_barcode_is_enabled,
        isRequired: batchConfig?.batch_barcode_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.batch_barcode_is_mandatory && !updatedBarcode) ? 'orgFormInputError' : ''} `}
                value={updatedBarcode}
                onChange={(e) => setUpdatedBarcode(e.target.value)}
                label="Barcode"
                required={batchConfig?.batch_barcode_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'AR #',
        isEnabled: batchConfig?.ar_number_is_enabled,
        isRequired: batchConfig?.ar_number_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.ar_number_is_mandatory && !updatedArNumber) ? 'orgFormInputError' : ''} `}
                value={updatedArNumber}
                onChange={(e) => setUpdatedArNumber(e.target.value)}
                label="AR #"
                required={batchConfig?.ar_number_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Roll No',
        isEnabled: batchConfig?.roll_no_is_enabled,
        isRequired: batchConfig?.roll_no_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.roll_no_is_mandatory && !updatedRollNumber) ? 'orgFormInputError' : ''} `}
                value={updatedRollNumber}
                onChange={(e) => setUpdatedRollNumber(e.target.value)}
                label="Roll No"
                required={batchConfig?.roll_no_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Last Qc Date',
        isEnabled: batchConfig?.last_qc_date_is_enabled,
        isRequired: batchConfig?.last_qc_date_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3Text
                text="Last Qc Date"
                className="filter__title"
                required={batchConfig?.last_qc_date_is_mandatory}
              />
              <DatePicker
                value={updatedLastQcDate}
                onChange={(value) => {
                  setUpdatedLastQcDate(value);
                }}
                style={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '2px',
                  height: '32px',
                  width: '100%',
                  background: 'white',
                }}
                format="DD-MM-YYYY"
                className={(formSubmitted && batchConfig?.last_qc_date_is_mandatory && !updatedLastQcDate) ? 'ShowInputError' : ''}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Next QC Date',
        isEnabled: batchConfig?.next_qc_date_is_enabled,
        isRequired: batchConfig?.next_qc_date_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3Text
                text="Next QC Date"
                className="filter__title"
                required={batchConfig?.next_qc_date_is_mandatory}
              />
              <DatePicker
                value={updatedNextQcDate}
                onChange={(value) => {
                  setUpdatedNextQcDate(value);
                }}
                format="DD-MM-YYYY"
                style={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '2px',
                  height: '32px',
                  width: '100%',
                  background: 'white',

                }}
                className={(formSubmitted && batchConfig?.next_qc_date_is_mandatory && !updatedNextQcDate) ? 'ShowInputError' : ''}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Freight Cost',
        isEnabled: batchConfig?.freight_cost_is_enabled,
        isRequired: batchConfig?.freight_cost_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.freight_cost_is_mandatory && !updatedFreightCost) ? 'orgFormInputError' : ''} `}
                value={updatedFreightCost}
                onChange={(e) => setUpdatedFreightCost(e.target.value)}
                label="Freight Cost"
                required={batchConfig?.freight_cost_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Other Cost',
        isEnabled: batchConfig?.other_cost_is_enabled,
        isRequired: batchConfig?.other_cost_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.other_cost_is_mandatory && !updatedOtherCost) ? 'orgFormInputError' : ''} `}
                value={updatedOtherCost}
                onChange={(e) => setUpdatedOtherCost(e.target.value)}
                label="Other Cost"
                required={batchConfig?.other_cost_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Landed Cost',
        isEnabled: batchConfig?.landed_cost_is_enabled,
        isRequired: batchConfig?.landed_cost_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.landed_cost_is_mandatory && !updatedLandedCost) ? 'orgFormInputError' : ''} `}
                value={updatedLandedCost}
                onChange={(e) => setUpdatedLandesCost(e.target.value)}
                label="Landed Cost"
                required={batchConfig?.landed_cost_is_mandatory}
                hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
                popOverMessage="You don't have access to view/edit cost price"
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Selling Price',
        isEnabled: batchConfig?.selling_price_is_enabled,
        isRequired: batchConfig?.selling_price_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.selling_price_is_mandatory && !updatedSellingPrice) ? 'orgFormInputError' : ''} `}
                value={updatedSellingPrice}
                onChange={(e) => setUpdatedSellingPrice(e.target.value)}
                label="Selling Price"
                required={batchConfig?.selling_price_is_mandatory}
                hideInput={isDataMaskingPolicyEnable && isHideSellingPrice}
                popOverMessage="You don't have access to view/edit selling price"
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Brand',
        isEnabled: batchConfig?.brand_is_enabled,
        isRequired: batchConfig?.brand_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.brand_is_mandatory && !updatedBrand) ? 'orgFormInputError' : ''} `}
                value={updatedBrand}
                onChange={(e) => setUpdatedBrand(e.target.value)}
                label="Brand"
                required={batchConfig?.brand_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Mfg Batch No',
        isEnabled: batchConfig?.mfg_batch_no_is_enabled,
        isRequired: batchConfig?.mfg_batch_no_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3FormInput
                labelClassName="orgFormLabel"
                inputClassName={`orgFormInput ${(formSubmitted && batchConfig?.mfg_batch_no_is_mandatory && !updatedMfgBatchNumber) ? 'orgFormInputError' : ''} `}
                value={updatedMfgBatchNumber}
                onChange={(e) => setUpdatedMfgBatchNumber(e.target.value)}
                label="Mfg Batch No"
                required={batchConfig?.mfg_batch_no_is_mandatory}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'Mfg Date',
        isEnabled: batchConfig?.manufacturing_date_is_enabled,
        isRequired: batchConfig?.manufacturing_date_is_mandatory,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3Text
                text="Mfg Date"
                className="filter__title"
                required={batchConfig?.manufacturing_date_is_mandatory}
              />
              <DatePicker
                value={updatedMfgDate}
                onChange={(value) => {
                  setUpdatedMfgDate(value);
                }}
                format="DD-MM-YYYY"
                style={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '2px',
                  height: '28px',
                  width: '100%',
                  background: 'white',

                }}
                className={(formSubmitted && batchConfig?.manufacturing_date_is_mandatory && !updatedMfgDate) ? 'ShowInputError' : ''}

              />
            </div>
          </div>
        ),
      },
    ];

    const batchCustomFields = CustomFieldHelpers.getCfStructure(customFieldsProps?.data?.batch_custom_fields, true);

    batchCustomFields?.map((field) => {
      initialColumns.push({
        title: field?.fieldName,
        isEnabled: field?.isActive,
        isRequired: field?.isRequired,
        render: (
          <div className="ant-col-md-12">
            <div className="filter__container filter__container-section">
              <H3Text
                text={field?.fieldName}
                className="filter__title"
                required={field?.isRequired}
              />
              <CustomFieldLine
                customFields={updatedCustomFields}
                cfId={field?.cfId}
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                formSubmitted={formSubmitted}
                customLineInputChange={(value) => { setUpdatedCustomFields(value); }}
                isUpdate
              />
            </div>
          </div>
        ),
      });
    });

    // sorting the fields annording to mandatory and non-mandatory
    const finalColumns = [];

    initialColumns?.filter((item) => item?.isRequired)?.map((item) => {
      finalColumns.push(item);
    });
    initialColumns?.filter((item) => !item?.isRequired)?.map((item) => {
      finalColumns.push(item);
    });

    return finalColumns;
  };

  const batchOptions = [
    { key: 0, value: '', label: 'All Batches' },
    { key: 1, value: 'Expired', label: 'Expired' },
    { key: 2, value: 'Near Expiry', label: 'Near Expiry (<25% Shelf Life)' },
    { key: 3, value: 'Good Stock', label: 'Healthy (>25% Shelf Life)' },
  ];

  const batchQuantityOptions = [
    { key: 0, value: '', label: 'All Batches' },
    { key: 1, value: 'POSITIVE_QUANTITY_BATCHES', label: 'Positive Quantity Batches' },
    { key: 2, value: 'NEGATIVE_QUANTITY_BATCHES', label: 'Negative Quantity Batches' },
    { key: 3, value: 'ZERO_QUANTITY_BATCHES', label: 'Zero Quantity Batches' },
  ];

  return (
    <div className="doc-list__wrapper doc-list__tab-content">
      <div className="ant-row">
        <div className="ant-col-xs-24">
          <div className="doc-list__header-wrapper">
            <div className="doc-list__header-wrapper__left">
              <div className="section-search">
                <div className="doc-list__search-bar__wrapper">
                  <div className="section-search-bar">
                    <input
                      value={searchKeyword}
                      placeholder="search for batch.."
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          setSearchKeyword(e.target.value);
                          setCurrentPage(1);
                          setLimit(10);
                          setCall(!call);
                        }
                      }}
                      onChange={(event) => {
                        setSearchKeyword(event.target.value);
                      }}
                    />
                    <H3Image
                      src={searchIcon}
                      className="section-search-bar__icon"
                      alt="search"
                      onClick={() => {
                        setSearchKeyword(searchKeyword);
                        setCurrentPage(1);
                        setLimit(10);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="doc-list__header-wrapper__right" />
          </div>
          <div className="flex-align-c" style={{ gap: '10px' }}>
            <UserSavedFilterViewSelector
              selectedFilterView={selectedFilterView}
              onChangeTab={(currentSelectedView) => {
                setSelectedFilterView(() => {
                  const currentSelectedViewFilters = currentSelectedView.filters;

                  const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                  const _batchDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                  let _batchStartDate = '';
                  let _batchEndDate = '';

                  if (_batchDateRangeType === '' || _batchDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_batchDateRangeType);
                    const [start, end] = date;
                    _batchStartDate = start;
                    _batchEndDate = end;
                    filterValue.startDate = _batchStartDate;
                    filterValue.endDate = _batchEndDate;
                  }

                  filterValue.batchDateRangeType = _batchDateRangeType;

                  const _expiryDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'expiryStartDate', valueOnly: false }).date_range_type;

                  let _expiryStartDate = '';
                  let _expiryEndDate = '';

                  if (_expiryDateRangeType === '' || _expiryDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_expiryDateRangeType);
                    const [start, end] = date;
                    _expiryStartDate = start;
                    _expiryEndDate = end;
                    filterValue.expiryStartDate = _expiryStartDate;
                    filterValue.expiryEndDate = _expiryEndDate;
                  }

                  filterValue.expiryDateRangeType = _expiryDateRangeType;

                  const tempFilterValues = filterValue;

                  setCurrentPage(1);
                  setLimit(tempFilterValues.limit || limit);
                  setSearchKeyword(tempFilterValues.keyword);
                  setPendingForQcRetest(tempFilterValues.pending_for_qc_retest);
                  setIsExpired(tempFilterValues.isExpired);
                  setSelectedTenant(tempFilterValues.tenant);
                  setSelectedDepartment(tempFilterValues.department_id);
                  setAvailableStocks(tempFilterValues.quantity_class);
                  setExpiryStatus(tempFilterValues.expiry_status);
                  setMaxCostPrice(tempFilterValues.maxCostPrice);
                  setMinCostPrice(tempFilterValues.minCostPrice);
                  setMaxMRP(tempFilterValues.maxMRP);
                  setSelectedCategory(tempFilterValues.categories);
                  setMinMRP(tempFilterValues.minMRP);
                  setStartDate(tempFilterValues.startDate);
                  setEndDate(tempFilterValues.endDate);
                  setBatchDateSelectedIntervalDateRangeType(tempFilterValues.batchDateRangeType);
                  setSortOrderByProductName(tempFilterValues.sortOrderByProductName);
                  setSortOrderByExpiryDate(tempFilterValues.sortOrderByExpiryDate);
                  setExpiryStartDate(tempFilterValues.expiryStartDate);
                  setExpiryEndDate(tempFilterValues.expiryEndDate);
                  setExpiryDateSelectedIntervalDateRangeType(tempFilterValues.expiryDateRangeType);
                  // setSelectedFilterTenantDepartment(Helpers.getTenantDepartmentId(user));
                  setIsRejectedBatch(tempFilterValues.isRejectedBatch);
                  setSelectedFilterInventoryLocation(tempFilterValues.inventory_location_id);
                  setSortOrder(tempFilterValues.sortOrder || 'ASC');

                  return currentSelectedView;
                });
              }}
              currentlyAppliedFilters={currentlyAppliedFilters}
              entityName={entityNameEnum.PRODUCT_BATCHES}
              setSavedFilterViews={(value) => setSavedFilterViews(value)}
              setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
              setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
              callback={() => {
                if (!isUserReadyInitial) setIsUserReadyInitial(true);
              }}
              systemDefaultUserView={systemDefaultUserView}
            />
            <div className="header__tags">
              {searchKeyword && (
                <Tag closable onClose={() => { setSearchKeyword(''); setCurrentPage(1); setCall(!call); }} color="#2d7df7">
                  Search results for -
                  &nbsp;
                  <span><b><i>{searchKeyword}</i></b></span>
                </Tag>
              )}
              {availableStocks && (
                <Tag closable onClose={() => { setAvailableStocks(''); setCurrentPage(1); }} color="#2d7df7">
                  Batch Qty -
                  &nbsp;
                  <span><b><i>{availableStocks.replaceAll('_', ' ')?.toProperCase()}</i></b></span>
                </Tag>
              )}
              {pendingForQcRetest && (
                <Tag closable onClose={() => { setPendingForQcRetest(false); setCurrentPage(1); }} color="#2d7df7">
                  &nbsp;
                  <span><b><i>Pending for QC Retest</i></b></span>
                </Tag>
              )}
              {(isRejectedBatch === true || isRejectedBatch === false) && (
                <Tag closable onClose={() => { setIsRejectedBatch(''); setCurrentPage(1); }} color="#2d7df7">
                  Batch Quality -
                  &nbsp;
                  <span><b>{isRejectedBatch ? 'BAD' : 'GOOD'}</b></span>
                </Tag>
              )}
              {selectedCategory && selectedCategory.map((item, index) => {
                const categoryName = subCategories ? findCategoryNameById(subCategories, item) : null;
                return (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedCategory(selectedCategory.filter((_, i) => i !== index));
                    }}
                    color="#2d7df7"
                  >
                    Category - &nbsp;
                    <span><b>{categoryName?.toUpperCase() || ''}</b></span>
                  </Tag>
                );
              })}
              {expiryStatus && (
                <Tag closable onClose={() => { setExpiryStatus(''); setCurrentPage(1); }} color="#2d7df7">
                  Expiry Status -
                  &nbsp;
                  {expiryStatus === 'Near Expiry' && <span><b>{'NEAR EXPIRY (<25% Shelf Life)'}</b></span>}
                  {expiryStatus === 'Good Stock' && <span><b>{'HEALTHY (>25% Shelf Life)'}</b></span>}
                  {expiryStatus === 'Expired' && <span><b>EXPIRED</b></span>}
                </Tag>
              )}
              {(['ASC', 'DESC'].includes(sortOrderByExpiryDate) || ['ASC', 'DESC'].includes(sortOrderByProductName)) && (
                <Tag closable onClose={() => { setSortOrderByExpiryDate(''); setSortOrderByProductName(''); }} color="#2d7df7">
                  Sort By -
                  &nbsp;
                  {['ASC', 'DESC'].includes(sortOrderByExpiryDate) && (
                    <div className="flex-display">
                      <b>EXPIRY</b>
                      <div style={{ marginLeft: '5px' }}>
                        {sortOrderByExpiryDate === 'DESC' ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                      </div>
                    </div>
                  )}
                  {['ASC', 'DESC'].includes(sortOrderByProductName) && (
                    <div className="flex-display">
                      <b>PRODUCT NAME</b>
                      <div style={{ marginLeft: 'auto' }}>
                        {sortOrderByProductName === 'DESC' ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                      </div>
                    </div>
                  )}
                </Tag>
              )}
              {
                (startDate && endDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setBatchDateSelectedIntervalDateRangeType('')
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    From:
                    &nbsp;
                    <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }
              {
                (expiryStartDate && expiryEndDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setExpiryEndDate(null);
                      setExpiryStartDate(null);
                      setExpiryDateSelectedIntervalDateRangeType('');
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    Expiry From:
                    &nbsp;
                    <span><b>{dayjs(expiryStartDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(expiryEndDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }
              {!!selectedDepartment && (
                <Tag
                  closable={!(Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility)}
                  onClose={() => {
                    setSelectedDepartment(null); setSelectedRowKeys(null);
                    setSelectedRows([]);
                  }}
                  color="#2d7df7"
                >
                  Department -
                  &nbsp;
                  <span><b>{departments?.data?.result?.departments?.find((department) => department?.department_id === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                </Tag>
              )}
              {selectedTenant && selectedTenant?.map((item) => (
                <div key={item}>
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                </div>
              ))}
            </div>
          </div>
          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    {`${batchesData?.data?.count || '0'} Batches`}
                  </div>
                  <div className="doc-list__table-header__right">
                    <div className="doc-list__filter-buttons">
                      {
                        batchesData && batchesData?.data?.count > 0
                        && (
                          <Popover
                            placement="bottom"
                            trigger="click"
                            title={<div>Please provide your email address</div>}
                            open={openPopover}
                            onOpenChange={() => setOpenPopover(!openPopover)}
                            content={(
                              <React.Fragment>
                                <div>
                                  <PRZSelect
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    mode="tags"
                                    filterOption={false}
                                    value={selectedEmails}
                                    onChange={(value) => setSelectedEmails(value)}
                                    disabled={downloadProductBatchesListLoading}
                                    maxTagCount="responsive"
                                    style={{
                                      width: '300px',
                                      paddingTop: '2px',
                                      height: 'auto !important',

                                    }}
                                  >

                                    {selectedEmails.length > 0 ? (
                                      selectedEmails.map((item) => (
                                        <Option key={item} value={item}>
                                          {item}
                                        </Option>
                                      ))
                                    ) : (
                                      <Option key={user?.email} value={user?.email}>
                                        {user?.email}
                                      </Option>
                                    )}

                                  </PRZSelect>
                                </div>
                                <div>
                                  <H3Button
                                    text="Send"
                                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                    onClick={() => { downloadHandler(); }}
                                    customClass="email-submit"
                                    isLoading={downloadProductBatchesListLoading}
                                    disabled={downloadProductBatchesListLoading}
                                  >
                                    Send

                                  </H3Button>
                                </div>

                              </React.Fragment>
                            )}
                          >
                            <div
                              className="action-buttons"
                              onClick={() => {
                                setOpenPopover(true);
                              }}
                            >
                              <H3Text
                                text={(
                                  <FontAwesomeIcon icon={faDownload} />
                                )}
                                className={`download-btn  ${downloadProductBatchesListLoading ? 'download-btn__disabled' : ''}`}
                              />
                            </div>
                          </Popover>

                        )
                      }
                      {selectedRowKeys?.length > 0 && (
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__sort-filter">
                              <H3Text
                                text="Adjust Quantity"
                                className="header__custom-dropdown__option"
                                onClick={() => {
                                  setShowMultiStockAdjustmentForm(true);
                                  setShowActionDropdown(false);
                                }}
                              />
                              <H3Text
                                text="Transfer Batches "
                                className="header__custom-dropdown__option"
                                onClick={() => {
                                  setShowActionDropdown(false);
                                  const batch = data;
                                  setShowStockTransferDrawer(true);
                                  setSelectedTenantDepartment(batch?.[0]?.tenant_department_id);
                                }}
                              />
                              <H3Text
                                text="Bulk Update "
                                className="header__custom-dropdown__option"
                                onClick={() => {
                                  setShowActionDropdown(false);
                                  setShowBulkUpdateBatchForm(true);
                                  const batch = data;
                                  setSelectedTenantDepartment(batch?.[0]?.tenant_department_id);
                                }}
                              />
                              {user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active && (
                                <H3Text
                                  text="Print Barcodes"
                                  className="header__custom-dropdown__option"
                                  onClick={() => {
                                    setShowActionDropdown(false);
                                    setShowPrintBarcodeDrawer(true);
                                  }}
                                />
                              )}

                              {user?.tenant_info?.quality_control_config?.sub_modules?.quality_control_rule?.is_active && (
                                <H3Text
                                  text="Send For QC"
                                  className="header__custom-dropdown__option"
                                  onClick={() => {
                                    const selectedIds = selectedRows?.map((item) => item?.batch_id);
                                    retestQualityCheck({ batch_ids: selectedIds, loadingHandler: getBatchesLoading }, () => {
                                      setSelectedRowKeys([]);
                                      setSelectedRows([]);
                                      setCall(!call);
                                    });
                                  }}
                                />
                              )}

                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper" onClick={() => setShowActionDropdown(true)}>
                            Actions
                            <CaretDownFilled />
                          </div>
                        </Dropdown>
                      )}

                    </div>
                    <div className="doc-list__action-buttons" onClick={showDrawer}>
                      <div className="action-button">
                        <H3Text text="Filters" className="action-button-text" />
                        <FilterOutlined />
                      </div>
                    </div>
                    <Dropdown
                      overlay={(
                        <div className="custom-columns__content">
                          <div className="custom-columns__content-section">
                            <H3Text text="Visible Columns" className="custom-columns__content-title" />
                            {
                              Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                <div key={key}>
                                  <Checkbox
                                    disabled={fixedColumns.includes(key)}
                                    checked={visibleColumns[key]?.visible}
                                    onChange={() => {
                                      const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                      visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                      localStorage.setItem('prcz-page-columns-inventory-lookup', JSON.stringify(visibleColumnsCopy));

                                      setVisibleColumns(visibleColumnsCopy);
                                    }}
                                  >
                                    {visibleColumns[key]?.label}
                                  </Checkbox>
                                </div>
                              ))
                            }
                          </div>
                          {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                            <div className="custom-columns__content-section">
                              <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                        localStorage.setItem('prcz-page-columns-inventory-lookup', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                          ) : ''}
                        </div>
                      )}
                      trigger={['click']}
                      placement="bottomRight"
                    >
                      <div className="custom-columns__wrapper">
                        Customize Columns
                        <ControlOutlined />
                      </div>
                    </Dropdown>
                    <Dropdown
                      overlay={(
                        <div className="custom-columns__sort-filter">
                          <H3Text
                            text={(
                              <div className="sort-by__dropdown-option">
                                Product Name
                                <div className="arrow">
                                  <ArrowUpOutlined />
                                </div>
                              </div>
                            )}
                            className={`header__custom-dropdown__option ${sortOrderByProductName === 'ASC' ? 'header__custom-dropdown__option-selected' : ''}`}
                            onClick={() => { setSortOrderByProductName('ASC'); setSortOrderByExpiryDate(''); }}
                          />

                          <H3Text
                            text={(
                              <div className="sort-by__dropdown-option">
                                Product Name
                                <div className="arrow">
                                  <ArrowDownOutlined />
                                </div>
                              </div>
                            )}
                            className={`header__custom-dropdown__option ${sortOrderByProductName === 'DESC' ? 'header__custom-dropdown__option-selected' : ''}`}
                            onClick={() => { setSortOrderByProductName('DESC'); setSortOrderByExpiryDate(''); }}
                          />
                          <H3Text
                            text={(
                              <div className="sort-by__dropdown-option">
                                Expiry Date
                                <div className="arrow">
                                  <ArrowUpOutlined />
                                </div>
                              </div>
                            )}
                            className={`header__custom-dropdown__option ${sortOrderByExpiryDate === 'ASC' ? 'header__custom-dropdown__option-selected' : ''}`}
                            onClick={() => { setSortOrderByProductName(''); setSortOrderByExpiryDate('ASC'); }}
                          />
                          <H3Text
                            text={(
                              <div className="sort-by__dropdown-option">
                                Expiry Date
                                <div className="arrow">
                                  <ArrowDownOutlined />
                                </div>
                              </div>
                            )}
                            className={`header__custom-dropdown__option ${sortOrderByExpiryDate === 'DESC' ? 'header__custom-dropdown__option-selected' : ''}`}
                            onClick={() => { setSortOrderByProductName(''); setSortOrderByExpiryDate('DESC'); }}
                          />
                        </div>
                      )}
                      trigger={['click']}
                      placement="bottomRight"
                    >
                      <div className="custom-columns__wrapper">
                        Sort By
                        <SwapOutlined />
                      </div>
                    </Dropdown>
                  </div>
                </div>
              )}
              showHeader
              loading={getBatchesDataLoading || retestQualityCheckLoading || savedFilterViewsLoading}
              size="small"
              columns={batchesColumns()}
              dataSource={data || []}
              scroll={!isMobileOrPortrait && !!data?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
              sticky={!isMobileOrPortrait && !!data?.length}
              bordered
              pagination={
                {
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: batchesData ? batchesData?.data?.count : 0,
                  pageSize: limit,
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                  },
                  position: ['bottomLeft'],
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }
              }
              rowSelection={!isMobile ? {
                onChange: (rowKeys, rows) => {
                  setSelectedRowKeys(rowKeys);
                  setSelectedRows(rows);
                },
                selectedRowKeys,
                getCheckboxProps: (record) => ({
                  disabled: selectedDepartment === null || !(selectedTenant.length === 1),
                }),
                onCell: () => ({
                  title: selectedDepartment === null && 'Select Department First',
                }),
              } : false}

            />
          </div>
        </div>
      </div>
      <Drawer width="390px" title="Basic Drawer" placement="right" onClose={onClose} open={open}>
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '345px' }}>
            <H3Text text="Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={onClose} />
          </div>
          <div className="header__filter__container-inventory-lookup">
            <div className="filter__container filter__container-section" style={{ marginTop: '55px' }}>
              <div className="filter__title"> Select Business Unit </div>
              <TenantSelector
                selectedTenant={selectedTenant}
                showSearch
                onChange={(value) => {
                  setSelectedTenant(value);
                }}
                placeholder="Select Business Unit"
                isMultiple
                hideTitle
                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ)}
              />
            </div>
            <div className="filter__container filter__container-section">
              <div className="filter__title">Batch Date</div>
              <H3DateSelector
                // innerfilter
                selectedInterval={batchDateSelectedIntervalDateRangeType}
                startDate={startDate}
                endDate={endDate}
                onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                  setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                  setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                  setBatchDateSelectedIntervalDateRangeType(dateRangeType);
                  setCurrentPage(1);
                  // pushParamsToUrl(1, limit, user?.tenant_info?.org_id, selectedTenant, sortOrder, isExpired, searchKeyword, getFormattedDate(date[0])?.valueOf(), getFormattedDate(date[1])?.valueOf(), selectedDepartment, expiryStartDate, expiryEndDate, sortOrderByProductName, sortOrderByExpiryDate, '', minCostPrice, maxCostPrice, minMRP, maxMRP, selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, '', availableStocks, pendingForQcRetest);
                }}
              />
            </div>
            <div className="filter__container filter__container-section">
              <div className="filter__title">Select Department</div>
              <SelectDepartment
                noDropdownAlign
                title="Select Department"
                hideTitle
                selectedDepartment={selectedDepartment && Number(selectedDepartment)}
                onChange={(value) => {
                  getInventoryLocations('', '', null, true, Helpers.getValueFromUrl('tenant') || selectedTenant || user?.tenant_info?.tenant_id, selectedDepartment?.toString());
                  setSelectedDepartment(value?.department_id || '');
                  setCurrentPage(1);
                }}
                disabled={getBatchesDataLoading || (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility)}
              />
            </div>
            <div className="filter__container filter__container-section">

              <div className="filter__title">Warehouse Bin</div>
              <PRZSelect
                disabled={!(selectedTenant.length === 1)}
                value={selectedFilterInventoryLocationName}
                loading={getInventoryLocationsLoading}
                filterOption={false}
                showSearch
                onChange={(value) => {
                  setSelectedFilterInventoryLocation(value);
                  setSelectedFilterInventoryLocationName(inventoryLocations?.inventory_location?.find((item) => item.inventory_location_id == value)?.inventory_location_path);
                }}
                onSearch={(keyword) => {
                  getInventoryLocations(selectedFilterTenantDepartment || '', keyword, null, true, Helpers.getValueFromUrl('tenant') || selectedTenant || user?.tenant_info?.tenant_id, selectedDepartment?.toString());
                }}
              >
                <Option key={0} value="">All Locations</Option>
                {
                  inventoryLocations?.inventory_location?.filter((item) => item?.is_active)?.map((item) => (
                    <Option
                      key={item?.inventory_location_id}
                      value={item?.inventory_location_id}
                    >
                      <H3Text text={item?.inventory_location_path} className="create-new-batch__location-item" />
                    </Option>
                  ))
                }
              </PRZSelect>
            </div>

            <div className="filter__container filter__container-section">
              <div className="filter__title">Expiry Date</div>
              <H3DateSelector
                selectedInterval={expiryDateSelectedIntervalDateRangeType}
                startDate={expiryStartDate}
                endDate={expiryEndDate}
                onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                  setExpiryStartDate(dayjs(date[0])?.startOf('day').valueOf());
                  setExpiryEndDate(dayjs(date[1])?.endOf('day').valueOf());
                  setExpiryDateSelectedIntervalDateRangeType(dateRangeType);
                  setCurrentPage(1);
                  // pushParamsToUrl(1, limit, user?.tenant_info?.org_id, selectedTenant, sortOrder, isExpired, searchKeyword, startDate, endDate, selectedDepartment, getFormattedDate(date[0])?.valueOf(), getFormattedDate(date[1])?.valueOf(), sortOrderByProductName, sortOrderByExpiryDate, '', minCostPrice, maxCostPrice, minMRP, maxMRP, selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, '', availableStocks, pendingForQcRetest);
                }}
              />
            </div>
            <div className="filter__container filter__container-section">
              <div className="filter__title">Batch Quality</div>
              <PRZSelect
                value={isRejectedBatch}
                onChange={(value) => { setIsRejectedBatch(value); }}
                disabled={!user?.tenant_info?.permission?.allow_to_change_product_batches_quality || getBatchesDataLoading}
              >
                <Option key={0} value="">All Batches</Option>
                <Option key={1} value={false}>
                  Good
                </Option>
                <Option key={2} value>
                  Bad
                </Option>
              </PRZSelect>

            </div>
            <div className="filter__container filter__container-section">

              <div className="filter__title"> Expiry Status  </div>
              <PRZSelect
                value={expiryStatus}
                disabled={getBatchesDataLoading}
                onChange={(value) => { setExpiryStatus(value); }}
                options={batchOptions}
              />

            </div>
            <div className="filter__container filter__container-section">

              <div className="filter__title">Product Category </div>
              <CategoryFilterNew
                selectedCategory={selectedCategory}
                containerClassName="section-status"
                hideTitle
                placeholder="Product Category"
                style={{
                  width: '100%',
                  height: '28px',
                  border: 'none',
                  borderRadius: '3px',
                }}
                onChange={(value, title) => {
                  setSelectedCategory(value);
                }}
                allowClear
              />
            </div>

            <div className="filter__container filter__container-section">

              <div className="filter__title">Available Stock</div>
              <PRZSelect
                allowClear
                value={availableStocks}
                filterOption={false}
                onChange={(value) => (setAvailableStocks(value))}
                showSearch={false}
                placeholder="Select Available Stock"
                maxTagCount="responsive"
                options={batchQuantityOptions}
              />
            </div>
            {user?.tenant_info?.quality_control_config?.sub_modules?.quality_control_rule?.is_active && (
              <div className="filter__container filter__container-section">
                <Checkbox
                  checked={pendingForQcRetest}
                  onChange={(e) => setPendingForQcRetest(e.target.checked)}
                >
                  <div className="filter__title">Pending For Quality Retest</div>
                </Checkbox>
              </div>
            )}
            <br />
          </div>
        </div>
      </Drawer>
      {/* drawer for Update  */}
      <Drawer width="590px" title="Basic Drawer" placement="right" onClose={() => setEditDrawer(false)} open={editDrawer}>
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '540px' }}>
            <H3Text text="Update Batch Information" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setEditDrawer(false)} />
          </div>
          <div className="header__filter__container-inventory-lookup inventory-lookup__update-form" style={{ paddingTop: '65px', paddingBottom: '65px' }}>
            {isDataMaskingPolicyEnable && (isHideCostPrice || isHideSellingPrice) && (
              <div className="ant-row">
                <div className="ant-col-md-24 mg-bottom-10">
                  <Alert message={`You don't have access to view/edit${isHideCostPrice ? ' cost price' : ''}${isHideCostPrice && isHideSellingPrice ? ' and' : ''}${isHideSellingPrice ? ' selling price' : ''}`} type="info" showIcon />
                </div>
              </div>
            )}
            <div className="ant-row">
              {batchDrawerFields()?.filter((item) => item?.isEnabled)?.map((item) => item?.render)}
            </div>
            <div className="custom-drawer__footer">
              <div className="ant-col-md-6">
                <H3Button
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  text="Update"
                  onClick={() => {
                    setFormSubmitted(true);
                    const payload = [{
                      batch_id: lineData?.batch_id,
                      custom_batch_number: updatedBatchNumber,
                      mrp: updatedMRP || null,
                      cost_price: updatedCostPrice || null,
                      selling_price: updatedSellingPrice || null,
                      inventory_location_id: selectedInventoryLocation || null,
                      lot_number: updatedLotNumber || null,
                      is_rejected_batch: updatedBatchQuality || false,
                      expiry_date: toISTDate(updatedExpiryDate) || null,
                      ar_number: updatedArNumber || null,
                      brand: updatedBrand || null,
                      freight_cost: updatedFreightCost || null,
                      landed_cost: updatedLandedCost || null,
                      last_qc_date: toISTDate(updatedLastQcDate) || null,
                      manufacturing_date: toISTDate(updatedMfgDate) || null,
                      mfg_batch_no: updatedMfgBatchNumber || null,
                      next_qc_date: toISTDate(updatedNextQcDate) || null,
                      other_cost: updatedOtherCost || null,
                      roll_no: updatedRollNumber || null,
                      batch_barcode: updatedBarcode || null,
                      custom_fields: CustomFieldHelpers.postCfStructure(updatedCustomFields),
                    }];
                    const isValid = validateBatchDetailsSimple(batchConfig, payload?.[0]);
                    const isExpiry = lineData?.expiry_date !== '2099-01-01' ? updatedExpiryDate : true;
                    if (isValid && isExpiry) {
                      updateBatch(payload, () => {
                        setFormSubmitted(false);
                        setCall(!call);
                        setEditDrawer(false);
                      });
                    }
                  }}
                  isLoading={updateBatchesLoading}
                  style={{
                    width: '160px',
                    borderRadius: '5px',
                    padding: '7px 0px',
                    marginLeft: '0',
                  }}
                  disabled={!isValidData(batchConfig)}
                />
              </div>
            </div>

          </div>
        </div>
      </Drawer>

      <Drawer
        open={showBulkUpdateBatchForm}
        onClose={() => setShowBulkUpdateBatchForm(false)}
        width="390px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '345px' }}>
            <H3Text text="Bulk Update Batches" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowBulkUpdateBatchForm(false)} />
          </div>
          <BulkUpdateBatchForm
            user={user}
            tenantId={selectedTenant?.[0]}
            batches={selectedRows}
            sourceTenantDepartmentId={selectedTenantDepartment}
            sourceDepartmentId={selectedDepartment}
            callback={() => {
              setCall(!call);
              setShowBulkUpdateBatchForm(false);
              setSelectedRows([]);
              setSelectedRowKeys(null);
            }}
          />
        </div>
      </Drawer>
      <Drawer
        open={showMultiStockAdjustmentForm}
        onClose={() => setShowMultiStockAdjustmentForm(false)}
        width="1080px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1045px' }}>
            <H3Text text="Adjust Quantity" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowMultiStockAdjustmentForm(false)} />
          </div>
        </div>
        <MultiStockAdjustmentForm
          user={user}
          tenantId={selectedTenant?.[0]}
          batches={selectedRows}
          adjustmentType="OUTWARD"
          tableType="STOCK_ADJUSTMENT"
          callback={() => {
            setCall(!call);
            setShowMultiStockAdjustmentForm(false);
            setSelectedRows([]);
            setSelectedRowKeys(null);
          }}
        />
      </Drawer>

      <Drawer
        open={showStockTransferDrawer}
        onClose={() => setShowStockTransferDrawer(false)}
        width="1080px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1035px' }}>
            <H3Text text="Transfer Batches" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowStockTransferDrawer(false)} />
          </div>
        </div>
        <MultiStockAdjustmentForm
          user={user}
          tenantId={selectedTenant?.[0]}
          sourceTenantDepartmentId={selectedTenantDepartment}
          sourceDepartmentId={selectedDepartment}
          sourceDepartmentName={departments?.data?.result?.departments?.find((department) => department?.department_id === Number(selectedDepartment))?.department_info?.department_name}
          batches={selectedRows}
          tableType="STOCK_TRANSFER"
          callback={() => {
            setCall(!call);
            setShowStockTransferDrawer(false);
            setSelectedRows([]);
            setSelectedRowKeys(null);
          }}
        />
      </Drawer>
      <Drawer
        placement="right"
        onClose={() => setShowPrintBarcodeDrawer(false)}
        open={showPrintBarcodeDrawer}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '310px' }}>
            <H3Text text="Print Barcodes" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowPrintBarcodeDrawer(false)} />
          </div>
        </div>
        <PrintBarcodes selectedRows={selectedRows} barcodeType="BATCH" />
      </Drawer>

      <Drawer
        open={showQCList}
        onClose={() => setShowQCList(false)}
        width="500px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '450px' }}>
            <H3Text text={`Quality Checks - ${lineData?.product_sku_name}`} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowQCList(false)} />
          </div>
        </div>
        <QCList selectBatch={lineData} />
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedProduct?.product_sku_name} - ${selectedProduct?.internal_sku_code}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          description={selectedProduct?.description}
          customFields={selectedProduct?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedProduct, MONEY, priceMasking })}
        />
      </Drawer>

    </div>

  );
}

const mapStateToProps = ({
  UserReducers, StockMasterReducers, InventoryLocationReducers, DepartmentReducers, CategoryReducers, ProductReducers, QualityCheckReducers, CFV2Reducers,
}) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  batchesData: StockMasterReducers.batchesData,
  getBatchesDataLoading: StockMasterReducers.getBatchesDataLoading,
  deleteBatchesLoading: StockMasterReducers.deleteBatchesLoading,
  updateBatchesLoading: StockMasterReducers.updateBatchesLoading,
  inventoryLocations: InventoryLocationReducers.inventoryLocations,
  departments: DepartmentReducers.departments,
  getInventoryLocationsLoading: InventoryLocationReducers.getInventoryLocationsLoading,
  getCategoriesLoading: CategoryReducers.getCategoriesLoading,
  categories: CategoryReducers.categories,
  MONEY: UserReducers.MONEY,
  downloadProductBatchesListLoading: ProductReducers.downloadProductBatchesListLoading,
  subCategories: CategoryReducers.subCategories,
  retestQualityCheck: QualityCheckReducers.retestQualityCheck,
  retestQualityCheckLoading: QualityCheckReducers.retestQualityCheckLoading,
  priceMasking: UserReducers.priceMasking,
  customFieldsProps: CFV2Reducers.cfV2DocProducts,
});
const mapDispatchToProps = (dispatch) => ({
  getCategories: (orgId, page, limit, searchKeyword) => dispatch(CategoryActions.getCategories(orgId, page, limit, searchKeyword)),
  getBatches: (payload, callback) => dispatch(StockMasterActions.getBatches(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback, tenantId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback, tenantId)),
  updateBatch: (payload, callback) => dispatch(StockMasterActions.updateBatches(payload, callback)),
  deleteBatch: (payload, callback) => dispatch(StockMasterActions.deleteBatches(payload, callback)),
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId) => dispatch(InventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId)),
  createIndent: (payload, callback, withApproval) => dispatch(ProductActions.createIndent(payload, callback, withApproval)),
  downloadProductBatchesList: (payload, callback) => dispatch(ProductActions.downloadProductBatchesList(payload, callback)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  getBatchesLoading: (payload, callback) => dispatch(StockMasterActions.getBatchesLoading(payload, callback)),
  retestQualityCheck: (payload, callback) => dispatch(QualityCheckActions.retestQualityCheck(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryLookup));
